// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:14:27

export default {
  "id": "relax-mini-games-collection",
  "slug": "relax-mini-games-collection",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/46f7fc2ae8374ad6856acce45bd7462a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/46f7fc2ae8374ad6856acce45bd7462a/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Relax Mini Games Collection",
      "description": "This is a collection of creative and fun mini-games. The game contains a variety of modes, you can DIY ice cream, have cooking for mooncakes, design a car of your favorite, and so on. You cant miss our game if you want to find some relaxation in your busy life.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "cleaning",
        "collect",
        "girls",
        "relax"
      ]
    },
    "zh-CN": {
      "title": "轻松迷你游戏集",
      "description": "这是一系列创意有趣的迷你游戏集合。游戏包含多种模式，你可以DIY冰淇淋，制作月饼，设计你最喜欢的汽车等等。如果你想在忙碌的生活中寻找一些放松，绝对不能错过我们的游戏。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "清洁",
        "收集",
        "女孩",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "放鬆迷你遊戲集合",
      "description": "這是一款創意與趣味的迷你遊戲集合。遊戲內容涵蓋多種模式，您可以DIY冰淇淋、製作月餅、設計您最喜歡的車輛等等。若您想在忙碌的生活中尋找一些放鬆，絕對不能錯過我們的遊戲。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "隨意"
      ],
      "tags": [
        "清潔",
        "收集",
        "女孩",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "放鬆迷你遊戲集合",
      "description": "這是一款集合創意和趣味迷你遊戲的集合。遊戲內容涵蓋多種模式，你可以自製冰淇淋、烹飪月餅、設計你喜愛的車輛等等。若你想在忙碌的生活中尋找一些放鬆時光，絕對不能錯過我們的遊戲。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "隨意"
      ],
      "tags": [
        "清潔",
        "收集",
        "少女",
        "放鬆"
      ]
    },
    "ja": {
      "title": "リラックスミニゲームコレクション",
      "description": "これは創造的で楽しいミニゲームのコレクションです。ゲームには様々なモードが含まれており、自分でアイスクリームを作成したり、月餅を作ったり、好きな車をデザインしたりすることができます。忙しい日常生活の中でリラックスしたい場合は、このゲームは見逃せません。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "掃除",
        "収集",
        "少女",
        "リラックス"
      ]
    },
    "ko": {
      "title": "리ラックス 미니 게임 콜렉션",
      "description": "이는 창의적이고 재미있는 미니 게임 컬렉션입니다. 게임에는 다양한 모드가 포함되어 있으며, 직접 아이스크림을 만들고, 달력을 요리하며, 자신의 좋아하는 차를 디자인할 수 있습니다. 바쁜 일상 속에서 조용한 시간을 찾고 싶다면 우리의 게임을 놓치지 마세요.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "청소",
        "모으기",
        "소녀들",
        "휴식"
      ]
    },
    "fr": {
      "title": "Collection de Mini Jeux Relax",
      "description": "C'est une collection de mini-jeux créatifs et amusants. Le jeu contient une variété de modes, vous pouvez créer votre propre glace à la fraise, cuisiner des mooncakes, concevoir une voiture de votre choix, etc. Vous ne devriez pas rater notre jeu si vous cherchez un peu de relaxation dans votre vie trépidante.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Casual"
      ],
      "tags": [
        "nettoyage",
        "collecter",
        "filles",
        "se détendre"
      ]
    }
  }
};
